import { apiClient } from '../client'
import type { portType } from '../../app/modules/types/port'
import type { OptionsType } from '../../app/modules/types/filters'
/**
 * Ports API endpoints
 */
export const portsApi = {
  /**
   * Get ports list
   */
  getList: async (params?: string): Promise<portType> => {
    const url = params ? `/port/?${params}` : '/port/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get port by ID
   */
  getById: async (portId: string): Promise<any> => {
    const { data } = await apiClient.get(`/port/${portId}/`)
    return data
  },

  /**
   * Get port statistics
   */
  getStats: async (): Promise<any> => {
    const { data } = await apiClient.get('/port/stats/')
    return data
  },

  /**
   * Get port filter options
   */
  getFilterOptions: async (): Promise<OptionsType> => {
    const { data } = await apiClient.get('/port/filter/')
    return data
  },
}
